import { render, staticRenderFns } from "./DealerPeakCustomerResyncComponent.vue?vue&type=template&id=0234ee04&scoped=true"
import script from "./DealerPeakCustomerResyncComponent.vue?vue&type=script&lang=js"
export * from "./DealerPeakCustomerResyncComponent.vue?vue&type=script&lang=js"
import "./DealerPeakCustomerResyncComponent.vue?vue&type=style&index=0&id=0234ee04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0234ee04",
  null
  
)

export default component.exports